<template>
  <v-form ref="form" v-model="valide">
    <DoubleTextFiels>
      <template #start>
        <v-menu
          v-model="menuDate"
          :close-on-content-click="false"
          class="menuDisplay"
          max-width="290px"
        >
          <template #activator="{ on }">
            <v-input class="noMarginOninput" v-on="on">
              <v-text-field
                readonly
                class="noMarginOninput"
                :class="{ required: required }"
                :value="formatDate(date)"
                prepend-icon="event"
                :label="textStart"
                :rules="required ? dateRules : []"
              />
            </v-input>
          </template>
          <v-date-picker v-model="getSetDate" />
          <v-btn block color="success" @click="menuDateBtnClick()">{{
            $tc('GENERAL.VALIDATE')
          }}</v-btn>
        </v-menu>
      </template>
      <template #end>
        <v-menu
          v-model="menuTime"
          :close-on-content-click="false"
          class="menuDisplay"
          max-width="290px"
        >
          <template #activator="{ on }">
            <v-input class="noMarginOninput" v-on="on">
              <v-text-field
                class="noMarginOninput"
                :class="{ required: required }"
                readonly
                :value="time"
                :label="textEnd"
                :rules="required ? timeRules : []"
              />
            </v-input>
          </template>
          <v-time-picker v-model="getSetTime" format="24hr" />
          <v-btn block color="success" @click="menuTimeBtnClick()">{{
            $tc('GENERAL.VALIDATE')
          }}</v-btn>
        </v-menu>
      </template>
    </DoubleTextFiels>
  </v-form>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import { i18n } from '../../../i18n/i18n'
import DoubleTextFiels from './DoubleTextField.vue'

export default defineComponent({
  components: {
    DoubleTextFiels,
  },

  props: {
    textStart: {
      type: String,
      default: '',
    },

    textEnd: {
      type: String,
      default: '',
    },

    value: {
      type: String as PropType<string | null | undefined>,
      required: true,
    },

    required: {
      type: Boolean,
      default: false,
    },

    // time used when a date is picked without a time; none: the time must be picked too
    defaultTime: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      valide: false,
      uid: Math.random().toString(36).substring(2, 9),
      date: '',
      time: '',
      menuDate: false,
      menuTime: false,

      timeRules: [
        (v: any): true | string => !!v || i18n.tc('FESTIVAL.RULES.TIME'),
      ],

      dateRules: [
        (v: any): true | string => !!v || i18n.tc('FESTIVAL.RULES.TIME'),
      ],
    }
  },

  computed: {
    getSetTime: {
      get() {
        return this.time
      },
      set(val: string) {
        this.time = val
        if (this.time && this.date) {
          this.$emit(
            'input',
            this.$dayjs(this.date + ' ' + this.time).toISOString(),
          )
        }
      },
    },

    getSetDate: {
      get() {
        return this.date
      },
      set(val: string) {
        this.date = this.$dayjs(val).format('YYYY-MM-DD')
        if (!this.time) {
          this.time = this.defaultTime
        }
        if (this.time && this.date) {
          this.$emit(
            'input',
            this.$dayjs(this.date + ' ' + this.time).toISOString(),
          )
        }
      },
    },
  },

  watch: {
    valide(val) {
      this.$emit('valide', val)
    },
    value: {
      handler(val: string) {
        if (val) {
          this.time = this.$dayjs(val).format('HH:mm')
          this.date = this.$dayjs(val).format('YYYY-MM-DD')
        } else {
          this.time = ''
          this.date = ''
        }
      },
      immediate: true,
    },
  },

  methods: {
    formatDate(date: string) {
      if (!date) {
        return ''
      }
      const formatted = this.$dayjs(date).format('DD/MM/YYYY')
      return formatted === 'Invalid date' ? '' : formatted
    },

    menuTimeBtnClick() {
      this.menuTime = false
    },

    menuDateBtnClick() {
      this.menuDate = false
    },
  },
})
</script>

<style lang="scss" scoped>
.noMarginOninput {
  margin-bottom: 0px;
  max-height: 66px;
}

.menuDisplay {
  display: flex;
}
</style>
